export default __webpack_public_path__ + "static/media/part_2_bt_1.58c5fde3.png";